export enum APIStatus {
    None = 0,
    WaitingForApprove = 1,
    Done = 2
}